module.exports = __webpack_public_path__ + "static/media/diversity-01-01.d0127340.svg";